import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { MACHINES } from '../engine/rules';

export default function Machines() {
  const [sel, setSel] = useState<string|null>(null);
  const all = Object.values(MACHINES) as any[];
  const m: any = sel ? MACHINES[sel] : null;
  const Row = ({l,v}:{l:string,v:string}) => (
    <div style={{display:'flex',justifyContent:'space-between',padding:'7px 0',borderBottom:'1px solid var(--c-border)',fontSize:13}}>
      <span style={{color:'var(--t-muted)'}}>{l}</span><span className="val-pill">{v}</span>
    </div>
  );
  return (
    <div className="fade-in">
      <div className="flex-between" style={{marginBottom:24}}>
        <h1>Machine Fleet</h1>
        <span className="badge badge-navy">{all.length} machines · {all.reduce((a,m)=>a+m.qty,0)} units</span>
      </div>
      <div style={{display:'grid',gridTemplateColumns:sel?'1fr 340px':'1fr',gap:20}}>
        <div>
          <h4 style={{marginBottom:12}}>Bolt Formers</h4>
          <div className="grid-2" style={{marginBottom:24}}>
            {all.filter(m=>m.type==='BOLT').map(m=>(
              <div key={m.id} className="card card-hover card-pad" onClick={()=>setSel(sel===m.id?null:m.id)}
                style={{borderLeft:`4px solid ${sel===m.id?'var(--c-blue)':'var(--c-border)'}`,cursor:'pointer',transition:'all 0.15s'}}>
                <div className="flex-between" style={{marginBottom:8}}>
                  <div style={{fontWeight:600,fontSize:14}}>{m.name}</div>
                  <div style={{display:'flex',gap:4}}>
                    <span className="badge badge-amber">BOLT</span>
                    {m.die_case_od&&<span className="badge badge-green" style={{fontSize:10}}><CheckCircle2 size={8}/>Confirmed</span>}
                  </div>
                </div>
                <div style={{fontSize:12,color:'var(--t-muted)'}}>Ø{m.wire_min}–{m.wire_max}mm · {m.stations} stations · {(m.force_kg/1000).toFixed(0)}t · ×{m.qty}</div>
              </div>
            ))}
          </div>
          <h4 style={{marginBottom:12}}>Nut Formers</h4>
          <div className="grid-2">
            {all.filter(m=>m.type==='NUT').map(m=>(
              <div key={m.id} className="card card-hover card-pad" onClick={()=>setSel(sel===m.id?null:m.id)}
                style={{borderLeft:`4px solid ${sel===m.id?'var(--c-blue)':'var(--c-border)'}`,cursor:'pointer',transition:'all 0.15s'}}>
                <div className="flex-between" style={{marginBottom:8}}>
                  <div style={{fontWeight:600,fontSize:14}}>{m.name}</div>
                  <span className="badge badge-blue">NUT</span>
                </div>
                <div style={{fontSize:12,color:'var(--t-muted)'}}>{m.nut_size} · {m.stations} stations · {(m.force_kg/1000).toFixed(0)}t · ×{m.qty}</div>
              </div>
            ))}
          </div>
        </div>
        {m && (
          <div className="card card-pad fade-in" style={{alignSelf:'start',position:'sticky',top:24}}>
            <div className="flex-between" style={{marginBottom:16}}>
              <h3>{m.name}</h3>
              <span className={`badge ${m.type==='BOLT'?'badge-amber':'badge-blue'}`}>{m.type}</span>
            </div>
            <Row l="Force" v={`${(m.force_kg/1000).toFixed(0)} tonnes`}/>
            <Row l="Stations" v={`${m.stations}`}/>
            <Row l="Quantity" v={`×${m.qty}`}/>
            <Row l="Wire range" v={`Ø${m.wire_min}–${m.wire_max}mm`}/>
            {m.cbf&&<Row l="CBF" v={m.cbf}/>}
            {m.die_case_od&&<>
              <div style={{margin:'14px 0 10px',paddingTop:14,borderTop:'1px solid var(--c-border)'}}>
                <h4>Confirmed Constants</h4>
              </div>
              <Row l="Die case OD" v={`Ø${m.die_case_od}mm −0.02`}/>
              <Row l="Die length" v={`${m.die_len}mm`}/>
              <Row l="KO pin length" v={`${m.ko_pin_len}mm`}/>
              <Row l="Punch case OD" v={`Ø${m.punch_case_od}mm`}/>
              <Row l="Punch case len" v={`${m.punch_case_len}mm`}/>
              <Row l="KO head flange" v="Ø25.0 ±0.10mm (EN-24)"/>
              <Row l="Concentricity" v="TIR 0.020mm"/>
            </>}
            {m.ko_pin_len&&m.type==='NUT'&&<>
              <div style={{margin:'14px 0 10px',paddingTop:14,borderTop:'1px solid var(--c-border)'}}>
                <h4>Confirmed Constants</h4>
              </div>
              <Row l="Nut size" v={m.nut_size}/>
              <Row l="KO pin length" v={`${m.ko_pin_len}mm`}/>
              <Row l="Punch length" v={`${m.punch_len}mm`}/>
              <Row l="Die height" v={`${m.die_h}mm`}/>
              <Row l="Die OD taper" v={`${m.die_taper}°`}/>
              <Row l="Finger length" v={`${m.finger_len}mm`}/>
              <Row l="Tail taper" v={`${m.tail_taper}°`}/>
            </>}
          </div>
        )}
      </div>
    </div>
  );
}
